import React, { useEffect, useState } from 'react'
import { useRedirect } from '../../../../../../hooks/useRedirect'
import { useRecoverSubmit } from '../passwordController'
import { getIdStatus } from '../passwordController'
import logoSB from '../../../../../../assets/img/logo-colores-originales-sin-bajada.png'
import { GenericInput } from '../../../../../../components/common/GenericInput/GenericInput'
import { useParams } from 'react-router-dom'
import { FormErrorMessage } from '../../../../../feedback/apiResponse/FormErrorMessage'

export const RecoverPasswordForm = () => {
  const [transactionStatus, setTransactionStatus] = useState(null)
  const [errorMessage, setErrorMessage] = useState('')
  const [requestType, setRequestType] = useState('')
  const [showPassword, setShowPassword] = useState(true)
  const [showConfirmPassword, setShowConfirmPassword] = useState(true)
  const { transactionId } = useParams()


  //! Permite saber si la solicitud fue usada y el tipo de solicitud
  useEffect(() => {

    const fetchStatusId = async () => {
      try {

        const response = await getIdStatus(transactionId)
        //console.log('getIdStatus: ', response)

        if (response.data) {
          setRequestType(response.data.requestType)

          //?Sea response.data.used === false o venga un status 409, se setea TransactionStatus
          if (response.status === 200) {
            setTransactionStatus(response.status)
          } 
        }else if (response.status === 409){
          setTransactionStatus(response.status)
          setErrorMessage(response.message)
        }

      } catch (error) {
        console.error(error)
        throw error
      }
    }

    fetchStatusId()

  }, [transactionStatus, transactionId])



  const { handleSubmit, register, onSubmit, errors, message, response } = useRecoverSubmit(transactionId)

  //?👉 Función para alternar la visibilidad de la contraseña
  const toggleEye = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword)
    } else {
      setShowConfirmPassword(!showConfirmPassword)
    }
  }

  //?Redireccion a mensaje exitoso 

  const { redirectTo } = useRedirect()

  useEffect(() => {    
    if (response) {

      redirectTo('/completed-form', response.status, {
        message: `${message}`,
        title: "¡Éxito!"
      });
    }
  }, [response, redirectTo, message]);

  return (
    <div className="form-container">
      {transactionStatus === null
        ?
        null
        :
        transactionStatus === 200
          ?


          <form className="form-login" onSubmit={handleSubmit(onSubmit)}>
            <div className="logo-login">
              <img src={logoSB} alt="logo" />
            </div>

            <h1 className="title">Recuperá tu contraseña</h1>

            <div className="form-floating mb-3">
              <GenericInput
                required={true}
                type={showPassword ? "password" : "text"}
                name="newPassword"
                register={register}
                errors={errors}
                label="Nueva Contraseña"
                placeholder="Nueva Contraseña"
              />
              <span className="span-eye toggle-password">
                <i
                  onClick={() => toggleEye("password")}
                  className={showPassword ? "bi bi-eye bi-class-eye" : "bi bi-eye-slash bi-class-eye"}
                ></i>
              </span>
            </div>

            <div className="form-floating mb-3">
              <GenericInput
                required={true}
                type={showConfirmPassword ? "password" : "text"}
                name="newPasswordConfirm"
                register={register}
                errors={errors}
                label="Confirmación"
                placeholder="Confirmación"
              />
              <span className="span-eye toggle-password">
                <i
                  onClick={() => toggleEye("confirmPassword")}
                  className={showConfirmPassword ? "bi bi-eye bi-class-eye" : "bi bi-eye-slash bi-class-eye"}
                ></i>
              </span>
            </div>

            <input type="submit" className="button" value="Registrar" />
          </form>


          :
          <FormErrorMessage 
          
          title='Recuperar contraseña'
          text={errorMessage}
          />

      }
    </div>


  );
};
